(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["guf-studio"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const small = matchMedia('(max-width: 749px)');
  const root = document.documentElement;
  const movieSections = new Set();
  const seen = new WeakSet();
  const active = () => !reduced.matches && !document.body.matches('.motion-off,.gg-motion-off,.gg-motion-subtle');
  let frame;
  const topButton = document.querySelector('[data-gs-top]');
  const header = document.querySelector('.guf-header-shell');
  function headerSize(){if(header)document.body.style.setProperty('--gs-header-height',`${header.getBoundingClientRect().height}px`);}
  headerSize();
  if(header && 'ResizeObserver' in window)new ResizeObserver(headerSize).observe(header);
  function update(){
    frame = null;
    if(topButton)topButton.hidden=scrollY<600;
    movieSections.forEach(section=>{
      if(!section.isConnected){movieSections.delete(section);return;}
      const enabled=active()&&!small.matches;
      section.classList.toggle('gs-scroll-ready',enabled);
      if(!enabled)return;
      const box=section.getBoundingClientRect();
      if(box.top>innerHeight || box.bottom<0)return;
      const progress=Math.max(0,Math.min(1,(innerHeight*.22-box.top)/Math.max(1,box.height-innerHeight)));
      section.style.setProperty('--cinema-scale',String(.72+.28*progress));
    });
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(update);}
  const reveals='[data-gs-reveal],.gs-page .gg-card,.gs-page .article-card,.gs-page .collection-tile,.faq-list details';
  const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('gs-pending');observer.unobserve(entry.target);}}),{threshold:.06}):null;
  function boot(scope=document){
    scope.querySelectorAll('[data-gs-cinema]').forEach(section=>{
      movieSections.add(section);
      const video=section.querySelector('video');
      if(video&&!seen.has(video)){seen.add(video);const sync=()=>video.closest('[data-gs-cinema-frame]').classList.toggle('gs-playing',!video.paused);video.addEventListener('play',sync);video.addEventListener('pause',sync);}
    });
    if(observer && active())scope.querySelectorAll(reveals).forEach(node=>{
      if(seen.has(node))return;seen.add(node);
      if(node.getBoundingClientRect().top<innerHeight)return;
      observer.observe(node);node.classList.add('gs-reveal','gs-pending');
    });
    schedule();
  }
  function preferences(){if(!active())document.querySelectorAll('.gs-pending').forEach(node=>node.classList.remove('gs-pending'));schedule();}
  reduced.addEventListener('change',preferences);small.addEventListener('change',schedule);
  addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',event=>boot(event.target));
  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:null;if(!target)return;
    if(target.closest('[data-gs-top]')){scrollTo({top:0,behavior:active()?'smooth':'auto'});return;}
    const link=target.closest('[data-gs-zoom]');
    if(link&&!event.ctrlKey&&!event.metaKey&&!event.shiftKey&&!event.altKey){
      const dialog=document.getElementById('GufImageZoom');
      const image=dialog?.querySelector('[data-gs-zoom-image]');
      if(!dialog?.showModal||!image)return;
      event.preventDefault();image.src=link.href;image.alt=link.querySelector('img')?.alt||'';
      dialog._returnFocus=link;dialog.showModal();document.body.classList.add('modal-open');dialog.querySelector('button')?.focus();
    }
    if(!target.closest('.nav-dropdown'))document.querySelectorAll('.desktop-nav .nav-dropdown[open]').forEach(menu=>menu.open=false);
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.desktop-nav .nav-dropdown[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary')?.focus();});});
  document.querySelectorAll('.desktop-nav .nav-dropdown').forEach(menu=>{
    menu.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&matchMedia('(min-width: 990px)').matches)menu.open=true;});
    menu.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse'&&!menu.contains(document.activeElement))menu.open=false;});
  });
  boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["guf-vfx-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('guf-vfx-video')) {
    customElements.define('guf-vfx-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.sync = () => {
          if (this.dataset.autoplay !== 'true') return;
          if (!this.visible || document.hidden) { this.video.pause(); return; }
          if (this.motion.matches || navigator.connection?.saveData) { this.video.pause(); return; }
          this.video.muted = true;
          this.video.play().catch(() => {});
        };
        document.addEventListener('visibilitychange', this.sync, options);
        this.motion.addEventListener('change', this.sync, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.sync();
          }, { threshold: 0.2 });
          this.observer.observe(this);
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.video?.pause();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
